import {
  AdminSalesReportCompletedType,
  AdminSalesReportType
} from '../enums/admin-sales-report-type.enum'

export interface IAdminSalesReportRequest {
  shopId: string
  type: AdminSalesReportType
  fromDate: string | Date | undefined
  toDate: string | Date | undefined
}

export interface IAdminSalesReportUpdateRequest {
  id?: string
  shopId: string
  notWorking: boolean
  vehicleInvoiced: number
  income: number
  day: Date
}

export interface IAdminSalesReport {
  id: string
  day: Date
  vehiclesInvoiced: number
  income: number
  completedBy: AdminSalesReportCompletedType
}

export interface IAdminSalesReportResponse {
  reports: IAdminSalesReport[]
}
